import type { InboxMessage } from './SupportChat';

export const matchInboxEcho = (messages: InboxMessage[], incoming: InboxMessage): InboxMessage | undefined => {
  if (!incoming.client_id || !incoming.conversation_id) return undefined;
  return messages.find(
    (message) =>
      message.client_id === incoming.client_id &&
      message.conversation_id === incoming.conversation_id &&
      ['sending', 'failed', 'unconfirmed'].includes(message.status || '')
  );
};
